module.exports = __webpack_public_path__ + "img/reminders-1.fca58c52.gif";